module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/mail_open_rate-808e17b93df5acec6755db5013b901f5.svg";